import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/zzz/ewm.png")